import React from "react"
export function RightArrow(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M10.869 2l6.916 7.446a.821.821 0 01.077 1.01l-.077.098L10.869 18l-1.106-1.108 5.67-6.106-13.43.02L2 9.21l13.414-.02-5.65-6.082L10.868 2z"
        fill="currentColor"
        fillRule="nonzero"
        id="prefix__right-arrow"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
